export default __webpack_public_path__ + "static/media/checkup.586cf82b.jpg";